module.exports = __webpack_public_path__ + "img/receipt.ecdf078c.svg";